import { parseDate } from '@techstyle/redux-core';
import { differenceInDays } from 'date-fns';
export default function getPostRegDaysFunction(_ref) {
  var dateTimeAdded = _ref.dateTimeAdded,
      getCurrentDate = _ref.getCurrentDate;

  var getDaysSinceJoining = function getDaysSinceJoining() {
    var memberJoinDateTime = parseDate(dateTimeAdded);
    return differenceInDays(getCurrentDate(), memberJoinDateTime);
  };

  return getDaysSinceJoining;
}